import { render, staticRenderFns } from "./hoteldetails.vue?vue&type=template&id=4e2d2ec2&scoped=true&"
import script from "./hoteldetails.vue?vue&type=script&lang=js&"
export * from "./hoteldetails.vue?vue&type=script&lang=js&"
import style0 from "./hoteldetails.vue?vue&type=style&index=0&id=4e2d2ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d2ec2",
  null
  
)

export default component.exports